import React, { useEffect, useState, useRef } from 'react';
import api from '../services/api';

const PanelTiempoReal: React.FC = () => {
  const [pagosHoy, setPagosHoy] = useState<any[]>([]);
  const [stats, setStats] = useState({ cobradoHoy: 0, cobradoMes: 0, cobradoMesAnterior: 0, totalClientes: 0, morosos: 0, cortados: 0 });
  const [loading, setLoading] = useState(true);
  const intervalRef = useRef<any>(null);

  const cargar = async () => {
    try {
      const [pagRes, cliRes, facRes] = await Promise.all([
        api.get('/pagos'),
        api.get('/clientes'),
        api.get('/facturas'),
      ]);
      const pagos = pagRes.data;
      const clientes = cliRes.data;
      const facturas = facRes.data;
      const hoy = new Date();
      const inicioMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
      const inicioMesAnterior = new Date(hoy.getFullYear(), hoy.getMonth() - 1, 1);
      const finMesAnterior = new Date(hoy.getFullYear(), hoy.getMonth(), 0);

      const pagosDeHoy = pagos.filter((p: any) => {
        const f = new Date(p.createdAt);
        return f.getDate() === hoy.getDate() && f.getMonth() === hoy.getMonth() && f.getFullYear() === hoy.getFullYear();
      });
      const pagosMes = pagos.filter((p: any) => new Date(p.createdAt) >= inicioMes);
      const pagosMesAnterior = pagos.filter((p: any) => {
        const f = new Date(p.createdAt);
        return f >= inicioMesAnterior && f <= finMesAnterior;
      });
      const morosos = clientes.filter((c: any) =>
        facturas.some((f: any) => f.clienteId === c.id && (f.estado === 'pendiente' || f.estado === 'vencido') && new Date(f.fechaVencimiento) < hoy)
      ).length;

      setPagosHoy(pagosDeHoy.slice(0, 10));
      setStats({
        cobradoHoy: pagosDeHoy.reduce((s: number, p: any) => s + Number(p.monto), 0),
        cobradoMes: pagosMes.reduce((s: number, p: any) => s + Number(p.monto), 0),
        cobradoMesAnterior: pagosMesAnterior.reduce((s: number, p: any) => s + Number(p.monto), 0),
        totalClientes: clientes.length,
        morosos,
        cortados: clientes.filter((c: any) => c.estado === 'cortado').length,
      });
    } catch {}
    finally { setLoading(false); }
  };

  useEffect(() => {
    cargar();
    intervalRef.current = setInterval(cargar, 30000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const variacion = stats.cobradoMesAnterior > 0
    ? ((stats.cobradoMes - stats.cobradoMesAnterior) / stats.cobradoMesAnterior * 100).toFixed(1)
    : '0';
  const subio = Number(variacion) >= 0;
  const meses = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
  const mesActual = meses[new Date().getMonth()];
  const mesAnterior = meses[new Date().getMonth() === 0 ? 11 : new Date().getMonth() - 1];

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h2 style={{ color:'#f1f5f9', margin:0, fontSize:24, fontWeight:800 }}>Panel en Tiempo Real</h2>
          <p style={{ color:'#64748b', margin:'4px 0 0', fontSize:13 }}>Actualizacion automatica cada 30 segundos</p>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <div style={{ width:8, height:8, borderRadius:'50%', background:'#22c55e', boxShadow:'0 0 8px #22c55e' }} />
          <span style={{ color:'#22c55e', fontSize:13, fontWeight:600 }}>En vivo</span>
        </div>
      </div>

      {/* Comparativo */}
      <div style={{ background:'#1e293b', borderRadius:12, border:'1px solid #334155', padding:20, marginBottom:20 }}>
        <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:15, marginBottom:16 }}>Comparativo mensual</div>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:16 }}>
          <div style={{ background:'#0f172a', borderRadius:10, padding:14 }}>
            <div style={{ color:'#64748b', fontSize:12, marginBottom:4 }}>{mesAnterior} (mes anterior)</div>
            <div style={{ color:'#94a3b8', fontSize:22, fontWeight:800 }}>S/. {stats.cobradoMesAnterior.toFixed(2)}</div>
          </div>
          <div style={{ background:'#0f172a', borderRadius:10, padding:14 }}>
            <div style={{ color:'#64748b', fontSize:12, marginBottom:4 }}>{mesActual} (mes actual)</div>
            <div style={{ color:'#38bdf8', fontSize:22, fontWeight:800 }}>S/. {stats.cobradoMes.toFixed(2)}</div>
          </div>
          <div style={{ background: subio ? '#22c55e11' : '#ef444411', borderRadius:10, padding:14, border:`1px solid ${subio ? '#22c55e33' : '#ef444433'}` }}>
            <div style={{ color:'#64748b', fontSize:12, marginBottom:4 }}>Variacion</div>
            <div style={{ color: subio ? '#22c55e' : '#ef4444', fontSize:22, fontWeight:800 }}>
              {subio ? '+' : ''}{variacion}%
            </div>
            <div style={{ color: subio ? '#22c55e' : '#ef4444', fontSize:11 }}>
              {subio ? 'Mejor que el mes anterior' : 'Menor que el mes anterior'}
            </div>
          </div>
        </div>

        <div style={{ marginTop:16 }}>
          <div style={{ display:'flex', justifyContent:'space-between', marginBottom:6 }}>
            <span style={{ color:'#64748b', fontSize:12 }}>{mesAnterior}: S/. {stats.cobradoMesAnterior.toFixed(2)}</span>
            <span style={{ color:'#64748b', fontSize:12 }}>{mesActual}: S/. {stats.cobradoMes.toFixed(2)}</span>
          </div>
          <div style={{ background:'#0f172a', borderRadius:999, height:10, overflow:'hidden', marginBottom:4 }}>
            <div style={{ width:`${Math.min(100, stats.cobradoMesAnterior > 0 ? stats.cobradoMesAnterior / Math.max(stats.cobradoMesAnterior, stats.cobradoMes) * 100 : 0)}%`, background:'#94a3b8', height:'100%', borderRadius:999, transition:'width 0.5s' }} />
          </div>
          <div style={{ background:'#0f172a', borderRadius:999, height:10, overflow:'hidden' }}>
            <div style={{ width:`${Math.min(100, stats.cobradoMes > 0 ? stats.cobradoMes / Math.max(stats.cobradoMesAnterior, stats.cobradoMes) * 100 : 0)}%`, background:'#38bdf8', height:'100%', borderRadius:999, transition:'width 0.5s' }} />
          </div>
        </div>
      </div>

      {/* KPIs */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(160px,1fr))', gap:12, marginBottom:20 }}>
        {[
          { label:'Cobrado hoy', value:`S/. ${stats.cobradoHoy.toFixed(2)}`, color:'#22c55e' },
          { label:'Pagos hoy', value:`${pagosHoy.length}`, color:'#38bdf8' },
          { label:'Total clientes', value:`${stats.totalClientes}`, color:'#a78bfa' },
          { label:'Morosos', value:`${stats.morosos}`, color:'#ef4444' },
          { label:'Cortados', value:`${stats.cortados}`, color:'#f59e0b' },
        ].map(s => (
          <div key={s.label} style={{ background:'#1e293b', borderRadius:10, padding:'14px 16px', border:`1px solid ${s.color}33` }}>
            <div style={{ color:'#64748b', fontSize:12, marginBottom:6 }}>{s.label}</div>
            <div style={{ color:s.color, fontSize:20, fontWeight:800 }}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* Pagos en vivo */}
      <div style={{ background:'#1e293b', borderRadius:12, border:'1px solid #334155', overflow:'hidden' }}>
        <div style={{ padding:'14px 18px', borderBottom:'1px solid #334155', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ color:'#f1f5f9', fontWeight:700, fontSize:15 }}>Pagos de hoy en tiempo real</span>
          <span style={{ background:'#22c55e22', color:'#22c55e', border:'1px solid #22c55e33', borderRadius:20, padding:'3px 10px', fontSize:12, fontWeight:700 }}>
            {pagosHoy.length} pagos
          </span>
        </div>
        {loading ? <div style={{ textAlign:'center', color:'#64748b', padding:32 }}>Cargando...</div> :
          pagosHoy.length === 0 ? <div style={{ textAlign:'center', color:'#64748b', padding:32 }}>Sin pagos hoy todavia</div> :
          pagosHoy.map((p: any, i: number) => (
            <div key={p.id} style={{ padding:'12px 18px', borderBottom:'1px solid #0f172a', display:'flex', justifyContent:'space-between', alignItems:'center',
              background: i === 0 ? '#22c55e08' : 'transparent',
              borderLeft: i === 0 ? '3px solid #22c55e' : '3px solid transparent' }}>
              <div>
                <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                  {i === 0 && <span style={{ background:'#22c55e', color:'white', borderRadius:20, padding:'1px 8px', fontSize:10, fontWeight:700 }}>ULTIMO</span>}
                  <span style={{ color:'#f1f5f9', fontWeight:600, fontSize:14 }}>{p.cliente?.nombres} {p.cliente?.apellidos}</span>
                </div>
                <div style={{ color:'#64748b', fontSize:12 }}>
                  {p.cobrador?.nombre} {p.cobrador?.apellido} &middot; {p.metodo}
                </div>
                <div style={{ color:'#475569', fontSize:11 }}>
                  {new Date(p.createdAt).toLocaleTimeString('es-PE', { hour:'2-digit', minute:'2-digit', second:'2-digit' })}
                </div>
              </div>
              <div style={{ color:'#22c55e', fontWeight:800, fontSize:18 }}>S/. {Number(p.monto).toFixed(2)}</div>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default PanelTiempoReal;